<template>
	<div class="p-3" v-if="windowWidth > 1000">
		<div class="pr-3 pb-3 pt-3 shadow border-15 overflow-hidden bg-white">
			<div class="w-100 text-center">
				<img
					class="m-auto w-75"
					:src="require('../assets/img/Logo_admin.svg')"
				/>
				<btn
					type="white"
					class="w-100"
					shadow="0"
					textClass="w-100 text-success"
					:text="'زمان باقی مانده '+now_dateC+' '"
					:img="require('../assets/img/Clock.svg')"
					style_btn="direction: ltr !important;"
					v-if="now_date>0"
					/>
				<btn
					type="white"
					class="w-100"
					shadow="0"
					textClass="w-100 text-danger"
					text="زمان شما به اتمام رسید"
					:img="require('../assets/img/Info-Triangle.svg')"
					style_btn="direction: ltr !important;"
					v-else
				/>
			</div>
			<hr class="mt-0 w-75 mb-3" />
			<router-link to="/ticket/list?knd_user=users" v-if="['0','3'].includes($localStorage.get('user').username.access_level)" >
				<btn
					:type="(select=='17') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover h-right"
					text="تیکت ها"
				/>
			</router-link>
			<a href="/users" v-if="['0'].includes($localStorage.get('user').username.access_level)" >
				<btn
					:type="(select=='2') ? 'success' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover h-right"
					text="کاربران"
					:img="require('../assets/img/Arrow_Down_white.svg')"
					style_btn="border-radius: 0px !important; border-top-right-radius: 10px !important; border-color: #ffffff00 !important;"
				/>
			</a>
			<a href="/users?status=1">
				<btn
					:type="($route.query.status==1) ? 'orange' : 'outline-success'"
					class="w-100"
					shadow="0"
					textClass="w-100  h-right"
					text="فعال"
					:number="number['users_1']"
					style_btn="border-radius: 0px !important;"
					v-if="select=='2' || $route.path=='/users'"
					/>
			</a>
			<a href="/users?status=0">
				<btn
					:type="($route.query.status==0) ? 'orange' : 'outline-success'"
					class="w-100"
					shadow="0"
					textClass="w-100  h-right"
					text="غیرفعال"
					:number="number['users_0']"
					style_btn="border-radius: 0px !important;"
					v-if="select=='2' || $route.path=='/users'"
					/>
			</a>
			<router-link to="/field/list" v-if="['0'].includes($localStorage.get('user').username.access_level)" >
				<btn
					:type="(select=='3.2') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover h-right"
					text="دپارتمان"
				/>
			</router-link>
			<router-link to="/admin/list" v-if="['0'].includes($localStorage.get('user').username.access_level)">
				<btn
					:type="(select=='7') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover h-right"
					text="مدیران"
				/>
			</router-link>
			<!-- <router-link to="/support/admin">
				<btn
					:type="(select=='5') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover h-right"
					text="پیام‌ها"
				/>
			</router-link> -->
			<btn
				class="w-100"
				shadow="0"
				textClass="w-100 border-hover text-danger"
				type="white"
				text="خروج"
				@clickMe="exit()"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../UI/button/btn.vue";
		import { hour2time} from  "../assets/library/convertTime.js";
		import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
		export default {
			name: 'headMenu',
			data(){
				return {
					hour2time: hour2time,
					baseurl: window.baseurl,
					now_date: 0,
					now_dateC: "",
					mgt: false, 
					submenu: [false,false,false],
					userL: false,
					user: [],
					number: {
						"active": 0,
						"inactive": 0,
						"poor": 0,
						"no_authentication": 0,
						"new": 0,
						"delete": 0,
					},
				}
			},
			props: {
				select:{
					default: "0"
				},
			},
			components: {
				btn,
			},
			mounted(){
				this.user = this.$localStorage.get("user");
				if(!this.$localStorage.get("login-time")){
					var time = new Date();
					this.$localStorage.set("login-time", (time.getHours()*60 + time.getMinutes()))
				}
				// this.teachers_count();
				this.show_time();
			},
			methods:{
				setStatus(){
					return this.$route.params.id;
				},
				//**********************************************************************
				teachers_count(THIS = this){
					window.$.post(this.baseurl+"admin/teachers_count", {
						role: this.$localStorage.get("user").username.role,
						token: this.$localStorage.get("user")
					}, function(D){
						THIS.number = D.data;
					}, "json");
				},
				//**********************************************************************
				check_menu(link){
					return (window.location.pathname == link);
				},
				//**********************************************************************
				open_submenu(i=0){
					this.submenu[i] = !this.submenu[i];
				},
				//**********************************************************************
				show_time(THIS = this){
					var H = (THIS.$localStorage.get("user").username.access_level == '0' || THIS.$localStorage.get("user").username.access_level == '3') ? 6 :	1;
					var login_time = (THIS.$localStorage.get("login-time") * 60) + (H * 60 * 60);
					var time = 0;
					setTimeout(() => {
						time = new Date();
						THIS.now_date = login_time - (time.getSeconds() + (time.getMinutes() * 60) + (time.getHours() * 60 * 60)) ;
						THIS.now_dateC = THIS.hour2time(THIS.now_date);
						if(THIS.now_date>0){
							THIS.show_time()
						}else{
							THIS.exit("زمان ورود شما به پایان رسیده است")
						}
					}, 1000)
				},
				//**********************************************************************
				exit(text=''){
					if(text==''){
						text = "آیا مطمئن هستید می خواهید از حساب کاربری خود خارج شوید.";
					}
					this.$swal.fire({
						position: 'center',
						type: '',
						title: "خروج از حساب",
						html: "<div class='text-center w-75 m-auto'><hr/>"+text+"</div>",
						showCloseButton: true,
						showConfirmButton: true,
						confirmButtonText: "خیر",
						confirmButtonClass:"btn btn-outline-success border w-50",
						showCancelButton: true,
						cancelButtonText: "بلی خروج!",
						cancelButtonClass:"btn btn-danger w-50",
					}).then((result) => {
						if (result.dismiss=="cancel") {
							this.$localStorage.remove('user');
							this.$router.push('/');
						}
					})
				}
			}
		}
	</script>
<style>
	@import "../css/templatemo-main.css";
	.swal2-actions {
    flex-wrap: nowrap !important;
	}
</style>
